import { Banner, Flex } from 'pcln-design-system'
import { Close } from 'pcln-icons'
import styled from 'styled-components'
export const StyledBanner = styled(Banner)`
  /* istanbul ignore next */
  ${({ theme }) => theme.mediaQueries.xl} {
    margin-left: 0;
    margin-right: 0;
  }
`

export const StyledFlexRight = styled(Flex)`
  float: right;
`

export const StyledFlexLeft = styled(Flex)`
  float: left;
`

export const StyledClose = styled(Close)`
  cursor: pointer;
`
